import React from "react";
import "./OrangeOutlineGrayFilledBtn.css";
import { Button } from "react-bootstrap";

function OrangeOutlineGrayFilledBtn({ btnText, onClick }) {
    return (
        <section className="OrangeOutlineGrayFilledBtn">
            <Button className="Orange_Btn" onClick={onClick}>{btnText}</Button>
        </section>
    );
}

export default OrangeOutlineGrayFilledBtn;
